export const environment = {
  production: false,
  testing: true,
  development: false,
  apiUrl: 'https://padronribera.apptest.servebbs.com/api',
};
